import Vue from 'vue'
import axios from "axios"
//720个人信息收集（杨斯匀）
export function getSellerInfo(params) {
  return axios.post(`/seller/2_1/sw/720/getSellerInfo`, params).then((res) => res.data);
}